import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,
import $ from 'jquery'

if (document.getElementById('page-top')) {
  // #page-topがあるページだけで実行
  page()
}

function page() {
  // Khởi tạo Swiper
  const swiper = new Swiper('.js_event', {
    slidesPerView: 1,
    spaceBetween: 16,
    loop: true,
    loopAdditionalSlides: 1,
    speed: 1000,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    grabCursor: true,
    watchSlidesProgress: true,
    navigation: {
      nextEl: '.topEvent .swiper-button-next',
      prevEl: '.topEvent .swiper-button-prev',
    },
    breakpoints: {
      600: {
        slidesPerView: 2,
      },
      1025: {
        slidesPerView: 4,
        spaceBetween: 32,
      },
    },
  })

  // Lắng nghe sự kiện thay đổi của dropdown
  document.getElementById('site-filter').addEventListener('change', function () {
    const selectedCategory = this.value
    filterSlides(selectedCategory)
  })

  // Hàm lọc slide
  function filterSlides(category) {
    const slides = document.querySelectorAll('.swiper-slide')

    slides.forEach((slide) => {
      if (category === 'all' || slide.getAttribute('data-site') === category) {
        slide.classList.remove('hidden')
      } else {
        slide.classList.add('hidden')
      }
    })

    // Cập nhật Swiper để điều chỉnh layout
    swiper.update()
  }

  // Khởi tạo với tất cả slide hiển thị
  filterSlides('all')

  // faq
  document.addEventListener('DOMContentLoaded', () => {
    const toggleButtons = document.querySelectorAll('.js__toggle')

    toggleButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const item = button.closest('.faq__item')
        const answer = item.querySelector('.faq__answer')
        const btnToggle = button.querySelector('.faq__toggle')

        if (answer.classList.contains('faq__answer--open')) {
          answer.classList.remove('faq__answer--open')
          btnToggle.classList.remove('minus')
          btnToggle.classList.add('plus')
        } else {
          answer.classList.add('faq__answer--open')
          btnToggle.classList.remove('plus')
          btnToggle.classList.add('minus')
        }
      })
    })
  })
}
